/**
 * Takes a real percentage number like 1.01 and displays it as 1.01%
 * Does not accept or convert decimal percentages
 * @param percentage
 * @param decimals
 * @returns
 */
export const displayPercentage = (percentage: number, decimals = 2) => {
  const formatted = percentage.toLocaleString("en-US", {
    style: "percent",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
  return formatted
}
